import React, { useEffect, useState } from "react";
import stylez from "../AddNewProducts/NewProduct.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../Configuration/axiosInstance";
import SuccessDialogue from "../../../Components/Shared/SuccessDialog/SuccessDialog";
import LoadingSpinner from "../../../Components/Shared/Loader/Loader";
import { FaArrowLeft } from "react-icons/fa";

const UpdateProduct = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [msg, setMsg] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [dialogBox, setDialogBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [availableParentProducts, setAvailableParentProducts] = useState([]);
  const [product, setProduct] = useState({
    productName: "",
    productId: "",
    sku: "",
    category: "",
    price: 0,
    gst: 10,
    productDescription: "",
    imageUrl: "",
    weight: 0,
    // ✅ NEW: Product relationship fields
    productType: "individual",
    parentProduct: null,
    multiplier: 1,
  });

  const navigationState = location?.state;
  const productData = navigationState?.product || location?.state;
  const returnToState = navigationState?.returnTo;

  // ✅ NEW: Fetch individual products for parent selection
  useEffect(() => {
    axiosInstance
      .get("products/allproducts?productType=individual")
      .then((response) => {
        setAvailableParentProducts(response.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching parent products:", error);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    const productId = productData?._id;

    if (productId) {
      axiosInstance
        .get(`products/${productId}`)
        .then((response) => {
          const productData = response.data.data;
          setProduct({
            ...productData,
            // ✅ NEW: Ensure product relationship fields are set
            productType: productData.productType || "individual",
            parentProduct: productData.parentProduct || null,
            multiplier: productData.multiplier || 1,
          });
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching product:", error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [refresh, productData?._id]);

  const handleInput = (e) => {
    const { name, value } = e.target;

    setProduct((prevValue) => {
      const updated = {
        ...prevValue,
        [name]: value,
      };

      // ✅ NEW: Auto-reset parent and multiplier when switching to individual
      if (name === "productType" && value === "individual") {
        updated.parentProduct = null;
        updated.multiplier = 1;
      }

      return updated;
    });
  };

  const handleSubmit = (e) => {
    setDialogBox(true);
    setMsg("Updating Product in the Database. Please wait...");

    // ✅ NEW: Validate bulk product requirements
    if (product.productType === "bulk") {
      if (!product.parentProduct) {
        setMsg("Please select a parent product for bulk items ❗");
        setTimeout(() => setDialogBox(false), 3000);
        return;
      }
      if (!product.multiplier || product.multiplier <= 0) {
        setMsg("Please enter a valid multiplier for bulk items ❗");
        setTimeout(() => setDialogBox(false), 3000);
        return;
      }
    }

    axiosInstance
      .post(`products/${productData?._id}`, product)
      .then((response) => {
        setMsg(response.data.message);
        setDialogBox(true);

        setTimeout(() => {
          setMsg("");
          setDialogBox(false);
          setRefresh((prevState) => !prevState);
          handleBackNavigation();
        }, 2000);
      })
      .catch((error) => {
        console.error("Error updating product:", error);
        setMsg("Error updating product. Please try again.");
        setTimeout(() => {
          setDialogBox(false);
        }, 3000);
      });
  };

  const handleBackNavigation = () => {
    if (returnToState) {
      navigate(returnToState.path, {
        state: {
          preserveState: true,
          page: returnToState.page,
          pageSize: returnToState.pageSize,
          sku: returnToState.sku,
          category: returnToState.category,
          searchCriteria: returnToState.searchCriteria,
        },
      });
    } else {
      navigate("/products");
    }
  };

  // ✅ NEW: Get selected parent product details
  const selectedParentProduct = availableParentProducts.find(
    (p) => p._id === product.parentProduct
  );

  return (
    <>
      <div className={stylez.headerContainer}>
        <div className={stylez.headerLeft}>
          <button
            className={stylez.backButton}
            onClick={handleBackNavigation}
            title="Back to Products"
          >
            <FaArrowLeft className={stylez.backIcon} />
            Back to Products
          </button>
        </div>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={stylez.box}>
          <SuccessDialogue show={dialogBox} msg={msg} />

          {/* ✅ NEW: Enhanced product info header */}
          <div className={stylez.productHeader}>
            <div className={stylez.productInfo}>
              <h3 className={stylez.productName}>{product.productName}</h3>
              <div className={stylez.productMeta}>
                <span className={stylez.productSku}>SKU: {product.sku}</span>
                <span className={stylez.productId}>
                  ID: {product.productId}
                </span>
                {product.category && (
                  <span className={stylez.productCategory}>
                    {product.category}
                  </span>
                )}
                {/* ✅ NEW: Product type badge */}
                <span
                  className={`${stylez.productTypeBadge} ${
                    stylez[product.productType]
                  }`}
                >
                  {product.productType === "individual"
                    ? "🔵 Individual"
                    : "📦 Bulk"}
                </span>
              </div>
            </div>
            {product.imageUrl && (
              <div className={stylez.productImagePreview}>
                <img
                  src={product.imageUrl}
                  alt={product.productName}
                  className={stylez.previewImage}
                />
              </div>
            )}
          </div>

          <div className={stylez.newContainer}>
            <div className={stylez.divs}>
              <label>Product Name: </label>
              <input
                name="productName"
                type="text"
                placeholder="Firebrand BBQ Pellets 10kg"
                value={product.productName}
                onChange={handleInput}
              />
              <label>Product ID:</label>
              <input
                name="productId"
                type="number"
                placeholder="10421"
                value={product.productId}
                onChange={handleInput}
              />
              <label>SKU: </label>
              <input
                name="sku"
                type="text"
                placeholder="FBPEL10KG"
                value={product.sku}
                onChange={handleInput}
              />

              {/* ✅ NEW: Product Type Selection */}
              <label>Product Type</label>
              <select
                name="productType"
                value={product.productType}
                onChange={handleInput}
                className={stylez.productTypeSelect}
              >
                <option value="individual">Individual Product</option>
                <option value="bulk">Bulk Product</option>
              </select>
            </div>

            <div className={stylez.divs}>
              <label>Category</label>
              <select
                name="category"
                value={product.category}
                onChange={handleInput}
              >
                <option>Select an Option</option>
                <option value="Fuel">Fuel</option>
                <option value="Accessories">Accessories</option>
                <option value="BBQs">BBQ's</option>
              </select>

              <label>WholeSale Price</label>
              <input
                name="price"
                type="number"
                step="0.01"
                placeholder="25.09"
                value={product.price}
                onChange={handleInput}
              />

              <label>Weight (kg)</label>
              <input
                name="weight"
                type="number"
                step="0.01"
                min="0"
                placeholder="10.0"
                value={product.weight}
                onChange={handleInput}
                className={stylez.weightInput}
              />

              <label>GST(% Percentage)</label>
              <input
                name="gst"
                type="number"
                step="0.01"
                placeholder="25.09"
                value={product.gst}
                onChange={handleInput}
              />

              {/* ✅ NEW: Bulk Product Fields */}
              {product.productType === "bulk" && (
                <>
                  <label>Parent Product *</label>
                  <select
                    name="parentProduct"
                    value={product.parentProduct || ""}
                    onChange={handleInput}
                    className={stylez.parentProductSelect}
                  >
                    <option value="">Select Parent Product</option>
                    {availableParentProducts.map((parentProd) => (
                      <option key={parentProd._id} value={parentProd._id}>
                        {parentProd.productName} ({parentProd.sku})
                      </option>
                    ))}
                  </select>

                  <label>Multiplier *</label>
                  <input
                    name="multiplier"
                    type="number"
                    min="1"
                    placeholder="10"
                    value={product.multiplier}
                    onChange={handleInput}
                    className={stylez.multiplierInput}
                  />
                </>
              )}
            </div>

            <div className={stylez.divs}>
              {/* ✅ NEW: Bulk Product Info Display */}
              {product.productType === "bulk" && selectedParentProduct && (
                <div className={stylez.bulkInfo}>
                  <h4>🔗 Bulk Product Configuration:</h4>
                  <p>
                    <strong>Parent Product:</strong>{" "}
                    {selectedParentProduct.productName}
                  </p>
                  <p>
                    <strong>Parent SKU:</strong> {selectedParentProduct.sku}
                  </p>
                  <p>
                    <strong>Multiplier:</strong> {product.multiplier}x
                  </p>
                  <p>
                    <small>
                      💡 Stock will be managed through the parent product
                    </small>
                  </p>
                </div>
              )}

              <label>Product Description:</label>
              <textarea
                name="productDescription"
                type="text"
                rows={product.productType === "bulk" ? 6 : 10}
                placeholder="Smoked food has never been easier with our all-natural BBQ pellets..."
                value={product.productDescription}
                onChange={handleInput}
              />

              <label>ImageUrl</label>
              <input
                name="imageUrl"
                type="text"
                placeholder="Image Url"
                value={product.imageUrl}
                onChange={handleInput}
              />
            </div>
          </div>

          <div className={stylez.actionButtons}>
            <button
              className={stylez.backBtn}
              onClick={handleBackNavigation}
              type="button"
            >
              <FaArrowLeft /> Cancel & Go Back
            </button>
            <button
              className="confirmBtn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Product"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateProduct;
